import { GAME_KEYS } from "@/store/game/game.constants"

export const WIDGET_STATES = {
  REGISTER: "register",
  INFO_SUPPORT: "info-support",
  SELECTING: "selecting",
  CONFIRMING: "confirming",
  CONFIRMING_INFO: "confirming-info",
  WAITING: "waiting",
  UNAVAILABLE: "unavailable",
  IN_SESSION: "in-session",
  REPORT_SESSION: "report-session",
  REPORT_SESSION_SUCCESS: "report-session-success",
  RATE_SESSION: "rate-session",
  RATE_SESSION_SUCCESS: "rate-session-success",
  EFFECTIVENESS_RATING: "effectiveness-rating",
  RELOAD_POINTS: "reload-points",
  PURCHASING_CREDIT_CARD_SELECT: "purchasing--credit-card-select",
  PURCHASING_CREDIT_CARD: "purchasing--credit-card",
  CREDIT_CARD_SUCCESS: "credit-card-success",
  CHECKOUT_CONFIRMATION: "checkout-confirmation",
}

export const WIDGET_MAPPED_COACH_STATUSES = {
  ONLINE: "online",
  BUSY: "busy",
  IN_SESSION: "in-session",
  OFFLINE: "offline",
}

export const DEFAULT_COACH_THUMBNAIL = "https://d17galhwha3ary.cloudfront.net/assets/instapro/instapro-default-avatar.png"

export const SPECIALTY_IMAGES = {
  // League of Legends
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: {
    "top": require("@/assets/images/coaching/widget/icons/specializations/leagueoflegends/top.png"),
    "jungle": require("@/assets/images/coaching/widget/icons/specializations/leagueoflegends/jungle.png"),
    "mid": require("@/assets/images/coaching/widget/icons/specializations/leagueoflegends/mid.png"),
    "support": require("@/assets/images/coaching/widget/icons/specializations/leagueoflegends/support.png"),
    "ad": require("@/assets/images/coaching/widget/icons/specializations/leagueoflegends/ad.png"),
  },
  // Fortnite
  [GAME_KEYS.FORTNITE]: {
    "building": require("@/assets/images/coaching/widget/icons/specializations/fortnite/building.svg"),
    "aiming": require("@/assets/images/coaching/widget/icons/specializations/fortnite/aim.svg"),
    "decision": require("@/assets/images/coaching/widget/icons/specializations/fortnite/decision.svg"),
  },
}

export const ESTIMATOR_LEAGUE_OF_LEGENDS_RANKS = [
  {
    name: "Iron IV",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/iron.png"),
    division: 1,
    difficulty: 2,
  },
  {
    name: "Iron III",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/iron.png"),
    division: 2,
    difficulty: 2,
  },
  {
    name: "Iron II",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/iron.png"),
    division: 3,
    difficulty: 2,
  },
  {
    name: "Iron I",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/iron.png"),
    division: 4,
    difficulty: 2,
  },
  {
    name: "Bronze IV",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/bronze.png"),
    division: 5,
    difficulty: 3,
  },
  {
    name: "Bronze III",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/bronze.png"),
    division: 6,
    difficulty: 3,

  },
  {
    name: "Bronze II",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/bronze.png"),
    division: 7,
    difficulty: 3,

  },
  {
    name: "Bronze I",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/bronze.png"),
    division: 8,
    difficulty: 3,
  },
  {
    name: "Silver IV",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/silver.png"),
    division: 9,
    difficulty: 4,
  },
  {
    name: "Silver III",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/silver.png"),
    division: 10,
    difficulty: 4,
  },
  {
    name: "Silver II",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/silver.png"),
    division: 11,
    difficulty: 4,
  },
  {
    name: "Silver I",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/silver.png"),
    division: 12,
    difficulty: 4,
  },
  {
    name: "Gold IV",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/gold.png"),
    division: 13,
    difficulty: 5,
  },
  {
    name: "Gold III",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/gold.png"),
    division: 14,
    difficulty: 5,
  },
  {
    name: "Gold II",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/gold.png"),
    division: 15,
    difficulty: 5,
  },
  {
    name: "Gold I",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/gold.png"),
    division: 16,
    difficulty: 5,
  },
  {
    name: "Platinum IV",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/platinum.png"),
    division: 17,
    difficulty: 6,
  },
  {
    name: "Platinum III",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/platinum.png"),
    division: 18,
    difficulty: 7,
  },
  {
    name: "Platinum II",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/platinum.png"),
    division: 19,
    difficulty: 8,
  },
  {
    name: "Platinum I",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/platinum.png"),
    division: 20,
    difficulty: 9,
  },
  {
    name: "Diamond IV",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/diamond.png"),
    division: 21,
    difficulty: 15,
  },
  {
    name: "Diamond III",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/diamond.png"),
    division: 22,
    difficulty: 21,
  },
  {
    name: "Diamond II",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/diamond.png"),
    division: 23,
    difficulty: 28,
  },
  {
    name: "Diamond I",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/leagueoflegends/diamond.png"),
    division: 24,
    difficulty: 36,
  },
]

export const ESTIMATOR_FORTNITE_RANKS = [
  {
    name: "Open 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_1.svg"),
    division: 1,
    difficulty: 2,
  },
  {
    name: "Open 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_2.svg"),
    division: 2,
    difficulty: 2,
  },
  {
    name: "Open 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_3.svg"),
    division: 3,
    difficulty: 3,
  },
  {
    name: "Open 4",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_4.svg"),
    division: 4,
    difficulty: 4,
  },
  {
    name: "Contender 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_5.svg"),
    division: 5,
    difficulty: 7,
  },
  {
    name: "Contender 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_6.svg"),
    division: 6,
    difficulty: 11,
  },
  {
    name: "Contender 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_7.svg"),
    division: 7,
    difficulty: 15,
  },
  {
    name: "Champion 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/fortnite/division_8.svg"),
    division: 8,
    difficulty: 22,
  },
]

export const ESTIMATOR_VALORANT_RANKS = [
  {
    name: "Iron 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/iron 1.png"),
    division: 1,
    difficulty: 2,
  },
  {
    name: "Iron 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/iron 2.png"),
    division: 2,
    difficulty: 2,
  },
  {
    name: "Iron 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/iron 3.png"),
    division: 3,
    difficulty: 3,
  },
  {
    name: "Bronze 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/bronze 1.png"),
    division: 4,
    difficulty: 3,
  },
  {
    name: "Bronze 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/bronze 2.png"),
    division: 5,
    difficulty: 3,
  },
  {
    name: "Bronze 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/bronze 3.png"),
    division: 6,
    difficulty: 3,
  },
  {
    name: "Silver 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/silver 1.png"),
    division: 7,
    difficulty: 4,
  },
  {
    name: "Silver 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/silver 2.png"),
    division: 8,
    difficulty: 4,
  },
  {
    name: "Silver 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/silver 3.png"),
    division: 9,
    difficulty: 4,
  },
  {
    name: "Gold 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/gold 1.png"),
    division: 7,
    difficulty: 5,
  },
  {
    name: "Gold 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/gold 2.png"),
    division: 8,
    difficulty: 5,
  },
  {
    name: "Gold 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/gold 3.png"),
    division: 9,
    difficulty: 5,
  },
  {
    name: "Platinum 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/platinum 1.png"),
    division: 10,
    difficulty: 6,
  },
  {
    name: "Platinum 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/platinum 2.png"),
    division: 11,
    difficulty: 6,
  },
  {
    name: "Platinum 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/platinum 3.png"),
    division: 12,
    difficulty: 6,
  },
  {
    name: "Immortal 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/immortal 1.png"),
    division: 13,
    difficulty: 7,
  },
  {
    name: "Immortal 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/immortal 2.png"),
    division: 14,
    difficulty: 7,
  },
  {
    name: "Immortal 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/valorant/immortal 3.png"),
    division: 15,
    difficulty: 7,
  },
]

export const ESTIMATOR_APEX_RANKS = [
  {
    name: "Bronze 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Bronze.svg"),
    division: 1,
    difficulty: 2,
  },
  {
    name: "Bronze 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Bronze.svg"),
    division: 2,
    difficulty: 2,
  },
  {
    name: "Bronze 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Bronze.svg"),
    division: 3,
    difficulty: 2,
  },
  {
    name: "Bronze 4",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Bronze.svg"),
    division: 4,
    difficulty: 2,
  },
  {
    name: "Silver 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Silver1.svg"),
    division: 5,
    difficulty: 3,
  },
  {
    name: "Silver 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Silver2.svg"),
    division: 6,
    difficulty: 3,
  },
  {
    name: "Silver 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Silver3.svg"),
    division: 7,
    difficulty: 3,
  },
  {
    name: "Silver 4",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Silver4.svg"),
    division: 8,
    difficulty: 3,
  },
  {
    name: "Gold 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Gold1.svg"),
    division: 9,
    difficulty: 4,
  },
  {
    name: "Gold 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Gold2.svg"),
    division: 10,
    difficulty: 4,
  },
  {
    name: "Gold 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Gold3.svg"),
    division: 11,
    difficulty: 4,
  },
  {
    name: "Gold 4",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Gold4.svg"),
    division: 12,
    difficulty: 4,
  },
  {
    name: "Platinum 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Platinum1.svg"),
    division: 13,
    difficulty: 5,
  },
  {
    name: "Platinum 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Platinum2.svg"),
    division: 14,
    difficulty: 5,
  },
  {
    name: "Platinum 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Platinum3.svg"),
    division: 15,
    difficulty: 5,
  },
  {
    name: "Platinum 4",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Platinum4.svg"),
    division: 16,
    difficulty: 5,
  },
  {
    name: "Diamond 1",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Diamond1.svg"),
    division: 17,
    difficulty: 6,
  },
  {
    name: "Diamond 2",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Diamond2.svg"),
    division: 18,
    difficulty: 6,
  },
  {
    name: "Diamond 3",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Diamond3.svg"),
    division: 19,
    difficulty: 6,
  },
  {
    name: "Diamond 4",
    icon: require("@/assets/images/coaching/widget/icons/game-ranks/apex/Diamond4.svg"),
    division: 20,
    difficulty: 6,
  },
]

export const SPECIALIZATION_GROUP_DISPLAY_MODES = {
  BY_CATEGORY: "by-category",
  BY_FOCUS: "by-focus",
}

export const GAME_SPECIALIZATION_LABELS = {
  [GAME_KEYS.LEAGUE_OF_LEGENDS]: {
    [GAME_KEYS.LEAGUE_OF_LEGENDS.TOP]: "Top Lane",
    [GAME_KEYS.LEAGUE_OF_LEGENDS.JUNGLE]: "Jungle",
    [GAME_KEYS.LEAGUE_OF_LEGENDS.MIDDLE]: "Middle",
    [GAME_KEYS.LEAGUE_OF_LEGENDS.BOTTOM]: "Bottom",
    [GAME_KEYS.LEAGUE_OF_LEGENDS.SUPPORT]: "Support",
  },
  [GAME_KEYS.SSBU]: {
    [GAME_KEYS.SSBU.HEAVY]: "Heavy",
    [GAME_KEYS.SSBU.SWORD]: "Sword",
    [GAME_KEYS.SSBU.PROJECTILE]: "Projectile",
    [GAME_KEYS.SSBU.RUSHDOWN]: "Rushdown",
  },
}



// WEBPACK FOOTER //
// ./src/store/coaching/widget/widget.constants.js